.flyout__wrapper {
  background-color: var(--color-uva-white);
  border-radius: 0.25rem;
  box-shadow: 0 3px 6px rgba(0 0 0 / 40%);
  display: flex;
  flex-direction: column;
  left: 0;
  padding: 1rem;
  position: fixed;
  top: calc(100% + 0.25rem);
  z-index: 1500;
}

.flyout__header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
  width: 100%;
}
